/**
 * Google Maps Styles
 *
 * Legacy HotPads map styles for light and dark themes.
 * These styles match the current production HotPads look.
 */

export type MapStyle = Array<google.maps.MapTypeStyle>;

/**
 * HotPads Light Theme (Legacy)
 * The classic HotPads map styling with warm tones and simplified features
 */
export const hotpadsLightStyle: MapStyle = [
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',

    stylers: [{ color: '#888888' }],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'all',

    stylers: [{ visibility: 'on' }, { hue: '#f0e0c8' }, { gamma: '1.75' }],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [{ visibility: 'on' }],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'labels.text',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',

    stylers: [{ color: '#edebdf' }, { visibility: 'on' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',

    stylers: [{ color: '#d8ebd2' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels',
    stylers: [{ visibility: 'on' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.school',
    elementType: 'all',
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'on' }, { lightness: 35 }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',

    stylers: [{ color: '#888888' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',

    stylers: [{ color: '#ffe7c5' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',

    stylers: [{ color: '#fadbaf' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry',
    stylers: [{ visibility: 'on' }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [{ lightness: 25 }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [{ lightness: 25 }],
  },
  {
    featureType: 'water',
    elementType: 'all',

    stylers: [{ color: '#9dced1' }, { visibility: 'on' }],
  },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
];

/**
 * HotPads Dark Theme
 * Dark mode map styling for improved night viewing
 */
export const hotpadsDarkStyle: MapStyle = [
  { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },

  { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },

  { elementType: 'labels.text.fill', stylers: [{ color: '#9ca5b3' }] },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',

    stylers: [{ color: '#9ca5b3' }],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'all',

    stylers: [{ color: '#242f3e' }, { visibility: 'on' }],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',

    stylers: [{ color: '#242f3e' }, { visibility: 'on' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',

    stylers: [{ color: '#9ca5b3' }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',

    stylers: [{ color: '#3a3a3a' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',

    stylers: [{ color: '#263c3f' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',

    stylers: [{ color: '#6b9a76' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',

    stylers: [{ color: '#38414e' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',

    stylers: [{ color: '#212a37' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',

    stylers: [{ color: '#9ca5b3' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',

    stylers: [{ color: '#746855' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',

    stylers: [{ color: '#746855' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',

    stylers: [{ color: '#1f2835' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',

    stylers: [{ color: '#9ca5b3' }],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',

    stylers: [{ color: '#2f3948' }],
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',

    stylers: [{ color: '#9ca5b3' }],
  },
  {
    featureType: 'water',
    elementType: 'all',

    stylers: [{ color: '#17263c' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',

    stylers: [{ color: '#17263c' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',

    stylers: [{ color: '#515c6d' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',

    stylers: [{ color: '#17263c' }],
  },
];

/**
 * Minimal style - removes most labels and POIs
 */
export const minimalStyle: MapStyle = [
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];
